// Runtime configuration. In production it's injected into window.__APP_CONFIG__
// by server.js before the bundle runs; in `vite dev` it falls back to VITE_* env vars.
declare global {
	interface Window {
		__APP_CONFIG__?: {
			fileUploadRoot?: string;
			/** Tenant key resolved from the Host header by server.js. */
			tenant?: string;
		};
	}
}

const runtime = typeof window !== "undefined" ? window.__APP_CONFIG__ ?? {} : {};

const config = {
	fileUploadRoot:
		runtime.fileUploadRoot ||
		import.meta.env.VITE_FILE_UPLOAD_ROOT ||
		"https://oo-file-service.test-1.fruster.se",
};

export const getPublicConfig = (name: keyof typeof config) => {
	return config[name];
};
